/* src/app/modules/print-cards/components/card-jig/card-jig.component.scss */
:host {
  position: relative;
  display: block;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}
/*# sourceMappingURL=card-jig.component.css.map */
